import React from "react";
import { Menu, MenuItem, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface DownloadMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onExport: (format: "markdown" | "word" | "txt") => void;
}

const DownloadMenu: React.FC<DownloadMenuProps> = ({ anchorEl, open, onClose, onExport }) => {
  const { t } = useTranslation();

  const handleExport = (format: "markdown" | "word" | "txt") => {
    onExport(format);
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <MenuItem onClick={() => handleExport("markdown")}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Markdown (.md)
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {t("deepResearch.downloadFormats.markdownDescription")}
          </Typography>
        </Box>
      </MenuItem>
      <MenuItem onClick={() => handleExport("word")}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Word (.docx)
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {t("deepResearch.downloadFormats.wordDescription")}
          </Typography>
        </Box>
      </MenuItem>
      <MenuItem onClick={() => handleExport("txt")}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Text (.txt)
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {t("deepResearch.downloadFormats.txtDescription")}
          </Typography>
        </Box>
      </MenuItem>
    </Menu>
  );
};

export default DownloadMenu;
